/** `describeShort` is sentence-case prose ("daily", "working days"); chips and tags want Title Case. */
export function frequencyLabel(value: string | null | undefined): string | null {

  if (typeof value !== 'string' || !value.trim()) return null;
  return value.replace(/(^|\s)([a-z])/g, (_, gap: string, letter: string) => `${gap}${letter.toUpperCase()}`);
}
